const COOKIE_NAME = "INR_THEME";

export function readThemePreference() {
  try {
    if (typeof document === "undefined") return false;
    const cookie = document.cookie
      .split(";")
      .map((part) => part.trim())
      .find((part) => part.startsWith(`${COOKIE_NAME}=`));
    return cookie === `${COOKIE_NAME}=dark`;
  } catch {
    return false;
  }
}

export function saveThemePreference(darkMode) {
  try {
    if (typeof document === "undefined") return;
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `${COOKIE_NAME}=${
      darkMode ? "dark" : "light"
    }; Max-Age=31536000; Path=/; SameSite=Lax${secure}`;
  } catch {
    // Cookie restrictions must not prevent changing the theme in this session.
  }
}
